import { css } from '@emotion/core';
import colors from '../../../styles/colors';
import theme from '../../../styles/customTheme';
import { PRIMARY_BLUE } from './constants';

export const TableStyle = css`
  cursor: pointer;
  &:hover,
  &:focus,
  &:active {
    background: #f7fafc;
  }
  &.activeRow {
    background: ${colors.gray[50]};
  }
  &:hover .rightArrow {
    opacity: 1;
    transform: translate(0, -50%);
  }
  &.dirty {
    background-color: ${colors.yellow[50]};
  }
`;

export const tabListStyle = {
  bg: theme.colors.white,
  borderRadius: theme.radii.md,
  fontSize: theme.fontSizes.sm,
  fontWeight: theme.fontWeights.bold,
  borderBottom: '1px solid #ECEFF1',
  px: theme.space[2],
  h: '54px',
};

export const componentTabStyle = {
  position: 'relative' as const,
  display: 'inline-flex',
  alignItems: 'stretch',
  justifyContent: 'center',
  textAlign: 'center' as const,
  px: 0,
  py: 0,
  fontWeight: 400,
  borderBottom: '2px solid transparent',
  _selected: { fontWeight: 700, borderBottomColor: PRIMARY_BLUE, color: PRIMARY_BLUE },
  _focus: { outline: 'none' },
};

export const componentTabPanelStyle = {
  borderRadius: 0,
  overflow: 'hidden',
  bg: theme.colors.white,
  p: 0,
};
